import React from "react";
import PropTypes from "prop-types";
import { Chip } from "@mui/material";

/**
 * StatusBadge - A reusable status badge component
 * @param {Object} props
 * @param {string} props.status - Status text
 * @param {string} props.type - Badge type: 'status', 'priority'
 */
const StatusBadge = ({ status, type = "status" }) => {
  const getStatusColor = (status) => {
    const statusColors = {
      OPEN: { bg: "#fff3e0", color: "#e65100", border: "#ffb74d" },
      CLOSED: { bg: "#e8f5e9", color: "#2e7d32", border: "#66bb6a" },
      ON_HOLD: { bg: "#e3f2fd", color: "#1565c0", border: "#42a5f5" },
      TERMINATED: { bg: "#ffebee", color: "#c62828", border: "#ef5350" },
    };
    return statusColors[status] || { bg: "#f5f5f5", color: "#616161", border: "#bdbdbd" };
  };

  const getPriorityColor = (priority) => {
    const priorityColors = {
      Low: { bg: "#e8f5e9", color: "#2e7d32", border: "#66bb6a" },
      Medium: { bg: "#fff3e0", color: "#e65100", border: "#ffb74d" },
      High: { bg: "#ffebee", color: "#c62828", border: "#ef5350" },
    };
    return priorityColors[priority] || { bg: "#f5f5f5", color: "#616161", border: "#bdbdbd" };
  };

  const colors = type === "priority" ? getPriorityColor(status) : getStatusColor(status);

  return (
    <Chip
      label={status}
      sx={{
        backgroundColor: colors.bg,
        color: colors.color,
        border: `2px solid ${colors.border}`,
        fontWeight: 700,
        fontSize: "0.813rem",
        padding: "6px 12px",
        height: "32px",
        borderRadius: "16px",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        },
      }}
    />
  );
};

StatusBadge.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.oneOf(["status", "priority"]),
};

StatusBadge.defaultProps = {
  type: "status",
};

export default StatusBadge;
